const defaultState = {
  user: {
    userSubscribed: false,
  },
};

export default defaultState;
